import * as React from 'react';
import { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import InputLabel from '@mui/material/InputLabel';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { visuallyHidden } from '@mui/utils';
import axios from 'axios';

export default function Hero() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value);
  };

  const handleEarlyAccessSubmit = async () => {
    if (!email) {
      alert('Please enter an email address.');
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('Please enter a valid email address.');
      return;
    }

    var requestData = { emailAddress: email, };

    setLoading(true);
    try {
      const response = await axios.post('https://api.vivachain.ai/v1/early-access', requestData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      
      if (response.status === 200) {
        alert('Thank you for signing up for early access!');
        setEmail('');
      } else {
        console.error('Error submitting early access:', response.data);
        alert('There was an issue signing you up. Please try again.');
      }
    } catch (error) {
      console.error('Error submitting early access:', error);
      alert('There was an error signing you up. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      id="home"
      sx={(theme) => ({
        width: '100%',
        minHeight: '100vh', 
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundImage: `url('/images/hero.jpg')`,
        display: 'flex',
        alignItems: 'center', 
        justifyContent: 'center', 
        ...theme.applyStyles('dark', {
          backgroundImage: `url('/images/hero.jpg')`,
        }),
      })}
    >
      <Container
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: { xs: 'center', md: 'flex-start' },
          justifyContent: 'flex-start',
          textAlign: { xs: 'center', md: 'left' },
          pt: { xs: 14, sm: 20 },
          pb: { xs: 8, sm: 12 },
          pl: { xs: 2, md: '50%' },
          pr: { xs: 2, md: '5%' },
        }}
      >
        <Stack
          spacing={2}
          useFlexGap
          sx={{ alignItems: 'center', width: { xs: '100%', sm: '70%' } }}
        >
          <Typography
            variant="h1"
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'column' },
              alignItems: 'center',
              fontSize: 'clamp(3rem, 10vw, 3.5rem)',
            }}
          >
            Revolutionize&nbsp;Your&nbsp;Life&nbsp;
            <Typography
              component="span"
              variant="h1"
              sx={(theme) => ({
                fontSize: 'inherit',
                color: 'primary.main',
                ...theme.applyStyles('dark', {
                  color: 'primary.light',
                }),
              })}
            >
              with VIVA
            </Typography>
          </Typography>
          <Typography
            sx={{
              textAlign: 'center',
              color: 'text.secondary',
              width: { sm: '100%', md: '80%' },
            }}
          >
            Meet the world’s first autonomous AI that integrates seamlessly, executes intelligently, and evolves with your needs. Start shaping your future today.
          </Typography>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1}
            useFlexGap
            sx={{ pt: 2, width: { xs: '100%', sm: '350px' } }}
          >
            <InputLabel htmlFor="email-hero" sx={visuallyHidden}>
              Email
            </InputLabel>
            <TextField
              id="email-hero"
              hiddenLabel
              size="small"
              variant="outlined"
              aria-label="Enter your email address"
              placeholder="Your email address"
              fullWidth
              value={email}
              onChange={handleEmailChange}
              slotProps={{
                htmlInput: {
                  autoComplete: 'off',
                  'aria-label': 'Enter your email address',
                },
              }}
            />
            <Button
              variant="contained"
              color="primary"
              size="small"
              sx={{ minWidth: 'fit-content' }}
              onClick={handleEarlyAccessSubmit}
              disabled={loading}
            >
              {loading ? 'Submitting...' : 'Early Access'}
            </Button>
          </Stack>
          <Typography
            variant="caption"
            color="text.secondary"
            sx={{ textAlign: 'center' }}
          >
            Claim Your Spot in Early Access
          </Typography>
        </Stack>
      </Container>
    </Box>
  );
}